export default {
  loading: false,
  members: [],
  member: {},
  totalCount: 0,
};
